import { render, staticRenderFns } from "./CardMeasurerDigital.vue?vue&type=template&id=6ca6c2c6&scoped=true&"
import script from "./CardMeasurerDigital.vue?vue&type=script&lang=js&"
export * from "./CardMeasurerDigital.vue?vue&type=script&lang=js&"
import style0 from "./CardMeasurerDigital.vue?vue&type=style&index=0&id=6ca6c2c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca6c2c6",
  null
  
)

export default component.exports